import { generalServiceV1API } from '@/store/api-instance'
import { IGetAvailableDateRequest } from '../interfaces/getAvailableDates/IGetAvailableDateRequest'
import { AxiosResponse } from 'axios'
import { CommonMutationType } from '../../common/mutation-type'

async function getAvailableDateAPI (queryParams: IGetAvailableDateRequest) {
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetFirstAvailableDate', { params: queryParams })
  return response.data
}

async function getCalendarAvailableDaysAPI (queryParams: IGetAvailableDateRequest) {
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetGlobalCalendar', { params: queryParams })
  let dates = []
  if (response.data) {
    dates = response?.data?.map((obj :any) => obj.globalDay)
  }
  return dates
}

async function getAvailableHoursAPI (queryParams: IGetAvailableDateRequest) {
  const response: AxiosResponse = await generalServiceV1API.get('orders/GetAvailableHours', { params: queryParams })
  return response?.data
}

export {
  getAvailableHoursAPI,
  getAvailableDateAPI,
  getCalendarAvailableDaysAPI
}
